import { supabase } from "@/lib/supabase-client";
import type { TwilioVoiceToken } from "./types";

export async function fetchVoiceToken(userId: string, accessToken: string): Promise<TwilioVoiceToken> {
  const { data, error } = await supabase.functions.invoke("twilio-voice-token", {
    body: { identity: userId },
    headers: { Authorization: `Bearer ${accessToken}` },
  });

  if (error) {
    throw new Error(`Failed to fetch voice token: ${error.message}`);
  }

  if (!data?.token) {
    throw new Error("No token returned from server");
  }

  return {
    token: data.token,
    identity: data.identity || userId,
    expiresAt: new Date(Date.now() + 3600 * 1000), // 1 hour from now
  };
}
